import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const PortfolioAccordion = ({
  portfolioBlock = [],
  updatePortfolioBlock,
  onDeletePortfolioBlock,
  setPortfolioIndex,
  allSkills = [],
  skillValue = null,
  skillSelectionHandler,
}) => {
  const { t } = useTranslation();

  return (
    <div className="accordion-item bg-transparent border-0">
      {/* ------ toggle accordion button start ------ */}
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseSummary"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseSummary"
        >
          {t("Portfolio Links")}
        </button>
      </h3>
      {/* ------ toggle accordion button end ------ */}

      <div
        id="panelsStayOpen-collapseSummary"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          <div className="fields-group mb-5">
            <div className="fields d-flex flex-column gap-3">
              {/* ------ links start ------ */}
              {portfolioBlock.map((portfolioBlockData, index) => {
                return (
                  <div className="field" key={index}>
                    <div className="row g-3 align-items-center">
                      <div className="col-lg-11">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Link")}
                          </span>
                          <a
                            href={portfolioBlockData}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fw-bold ps-3 mb-0 text-dark text-truncate d-block"
                          >
                            {portfolioBlockData}
                          </a>
                        </div>
                      </div>
                      <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                        <Link
                          to="#"
                          className="text-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#savePortfolioLinkModal"
                          onClick={() =>
                            updatePortfolioBlock(portfolioBlockData, index)
                          }
                        >
                          <span className="d-block material-symbols-outlined">
                            edit
                          </span>
                        </Link>
                        <button
                          type="button"
                          className="btn p-0 border-0 bg-transparent text-danger"
                          onClick={() => onDeletePortfolioBlock(index)}
                        >
                          <span className="d-block material-symbols-outlined">
                            delete
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* ------ experience list section end ------ */}
            </div>

            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#savePortfolioLinkModal"
              onClick={() => {
                setPortfolioIndex(null);
              }}
              className="btn btn-outline-primary d-inline-flex align-items-center gap-1 mt-3"
            >
              <span className="d-block material-symbols-outlined">add</span>
              <span className="d-block">{t("Add Portfolio Link")}</span>
            </Link>
          </div>

          {/* ------ skill selection section start ------ */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Additional Skills")}
            </label>
            <div className="field-container ps-0 body-bg rounded-10">
              <Select
                isMulti
                className="w-100"
                placeholder={t("Select Skills")}
                options={allSkills}
                value={skillValue}
                onChange={(val) => {
                  skillSelectionHandler(val);
                }}
              />
            </div>
          </div>
          {/* ------ skill selection section end ------ */}
        </div>
      </div>
    </div>
  );
};

export default PortfolioAccordion;
